import type { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { Challenges } from '../editor/types/Experiments';

export const isPricingPlansV3Enabled = (flowAPI: ControllerFlowAPI) => {
  return flowAPI.experiments.enabled(Challenges.pricingPlansV3);
};
